import _defineProperty from "@babel/runtime/helpers/defineProperty";
export const Environment = {
  isServer: () => typeof window === 'undefined'
};
class WixServerModel {
  constructor() {
    _defineProperty(this, "wixServerParams", void 0);
    this.wixServerParams = this.init();
  }
  init() {
    if (Environment.isServer()) {
      return {};
    }
    try {
      var _wixServerDataElement;
      const wixServerDataElement = document.querySelector('#WIX_SERVER_DATA');
      const content = (wixServerDataElement == null || (_wixServerDataElement = wixServerDataElement.textContent) == null ? void 0 : _wixServerDataElement.trim()) || '{}';
      if (typeof window.ejsUnserialize === 'function') {
        return window.ejsUnserialize(content);
      }
      return JSON.parse(content);
    } catch (err) {
      console.error(`Wix Server Params failed to initialize`, err);
      return {};
    }
  }
  get() {
    return this.wixServerParams;
  }
}
export const wixServerData = new WixServerModel();
//# sourceMappingURL=wixServerData.js.map